/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedTopTileController_itemSearch$ref = any;
export type SbSharedTopTileController_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly code: string | null;
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly priceTiles: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly browseContentModule: {
        readonly moduleType: string | null;
    } | null;
    readonly " $refType": SbSharedTopTileController_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedTopTileController_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "contentModuleId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "code",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "priceTiles",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "isTrade",
                    "variableName": "isTrade"
                }
            ],
            "concreteType": "SearchBrowsePriceTile",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "browseContentModule",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentModuleId",
                    "variableName": "contentModuleId"
                }
            ],
            "concreteType": null,
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "moduleType",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'fab9bd034e7daa59b90a97c096626509';
export default node;
